import { render, staticRenderFns } from "./parent-list-page.vue?vue&type=template&id=32af5047&"
import script from "./parent-list-page.vue?vue&type=script&lang=js&"
export * from "./parent-list-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports